module.exports = __webpack_public_path__ + "img/arrow-left-blue.ab4351c6.svg";